module.exports = __webpack_public_path__ + "fonts/font.4eb94200.woff";